module.exports = __webpack_public_path__ + "static/sherlocked-banner-003b987845ba994846b89903b3c10a83.jpg";